module.exports = __webpack_public_path__ + "static/img/stuck-im-neubau.e098e6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stuck-im-neubau.jpg
// module id = fqCU
// module chunks = 1